/* eslint-disable react/react-in-jsx-scope */

import { useLoginApi } from '../../apiHooks/apiHooks';

function withFetchOrgAndOrgAliasHook (Component) {
  return function WrappedComponent (props) {
    const { fetchOrgAndOrgAlias } = useLoginApi();
    return <Component fetchOrgAndOrgAlias={fetchOrgAndOrgAlias} {...props} />;
  };
}

export default withFetchOrgAndOrgAliasHook;